var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content v-center"},[_c('AvatarBuilder',{on:{"avatarChange":_vm.avatarChange}}),_c('RoundedButton',{on:{"click":_vm.storeAvatar}},[_vm._v("Klar!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }